<template>
	<v-row class="my-0">
		<v-col class="py-0">
			<div v-if="lableText.length !== 0" :class="disabled ? 'lable-text-disable':'lable-text'">{{ lableText }}</div>
			<v-menu
				v-if="$vuetify.breakpoint.smAndDown"
				v-model="menu"
				:close-on-content-click="false"
				offset-y
				min-width="auto"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-bind="attrs"
						v-on="on"
						:value="isSuggestion ? '' : displayDateRange"
						:color="color"
						:background-color="background"
						transition="scale-transition"
						ref="inputRef"
						outlined
						dense
						persistent-hint
						readonly
						:hide-details="hideDetails"
						:placeholder="isSuggestion ? displayDateRange :`${startText} to ${endText}`"
						:clearable="clearable"
						:disabled="disabled"
						:hint="suggestionText"
						:error="error || date_message.length !== 0"
						:messages="date_message"
						@click:clear="onClear()"
						@input="onInputClear($event)"
						@change="onDateTextChange($event)"
						@keydown="onKeydown($event)"
					>
						<template v-if="isIcon" v-slot:prepend-inner>
							<div v-bind="attrs" v-on="on">
								<Calendar color="rgba(25, 42, 62, 0.5)" width="20" height="20" style="margin-top: 2px"/> 				
							</div>
						</template>
					</v-text-field>
				</template>
				<v-card>
					<v-row>
						<v-date-picker
							v-model="dates"
							:color="color"
							no-title
							scrollable
							range
							next-icon=""
							:allowedDates="allowedDates"
							:max="maxPreMonth"
							:picker-date.sync="pickerPreDate"
							@update:picker-date="onPreMonthChange($event)"
							@input="onDateChange($event)">
						</v-date-picker>
						<v-date-picker
							v-model="dates"
							:color="color"
							no-title
							scrollable
							range
							prev-icon=""
							:allowedDates="allowedDates"
							:min="minNextMonth"
							:picker-date.sync="pickerNextDate"
							@update:picker-date="onNextMonthChange($event)"
							@input="onDateChange($event)"
						></v-date-picker>
					</v-row>
				</v-card>
			</v-menu>
			<v-text-field
				v-if="!$vuetify.breakpoint.smAndDown"
				:value="isSuggestion ? '' : displayDateRange"
				:color="color"
				:background-color="background"
				transition="scale-transition"
				ref="inputRef"
				outlined
				dense
				persistent-hint
				:hide-details="hideDetails"
				:placeholder="isSuggestion ? displayDateRange :`${startText} to ${endText}`"
				:clearable="clearable"
				:disabled="disabled"
				:hint="suggestionText"
				:error="error || date_message.length !== 0"
				:messages="date_message"
				@click:clear="onClear()"
				@input="onInputClear($event)"
				@change="onDateTextChange($event)"
				@keydown="onKeydown($event)"
			>
				<template v-if="isIcon" v-slot:prepend-inner>
					<v-menu
						v-model="menu"
						:close-on-content-click="false"
						:disabled="disabled"
						offset-y
						min-width="auto"
					>
						<template v-slot:activator="{ on, attrs }">
							<div v-bind="attrs" v-on="on">
								<Calendar color="rgba(25, 42, 62, 0.5)" width="20" height="20" style="margin-top: 2px"/> 
							</div>
						</template>
						<v-card>
							<v-row>
								<v-date-picker
									v-model="dates"
									:color="color"
									no-title
									scrollable
									range
									next-icon=""
									:allowedDates="allowedDates"
									:max="maxPreMonth"
									:picker-date.sync="pickerPreDate"
									@update:picker-date="onPreMonthChange($event)"
									@input="onDateChange($event)">
								</v-date-picker>
								<v-date-picker
									v-model="dates"
									:color="color"
									no-title
									scrollable
									range
									prev-icon=""
									:allowedDates="allowedDates"
									:min="minNextMonth"
									:picker-date.sync="pickerNextDate"
									@update:picker-date="onNextMonthChange($event)"
									@input="onDateChange($event)"
								></v-date-picker>
							</v-row>
						</v-card>
					</v-menu>
				</template>
			</v-text-field>
			<div v-if="isOptional" class="optional-text">optional</div>
		</v-col>
	</v-row>
</template>
<script>
import Calendar from "@/components/icons/calendar.vue";
import moment from 'moment';
import config from "@/config.js";

/** 31 days for a month, (0?[1-9]|[12]\d|3[01])-(0?[13578]|1[02])-((19|20)\d{2}) */
/** 30 days for a month, (0?[1-9]|[12]\d|30)-(0?[469]|11)-((19|20)\d{2}) */
/** 28 days for a month, (0?[1-9]|1\d|2[0-8])-0?2-((19|20)\d{2}) */
/** 29 days for a month, (0?[1-9]|[12]\d)-0?2-((19|20)([13579][26]|[2468][048]|0[48])) */
/** DATE_FORMAT_REG3, day or day+month or day+month+year
const DATE_FORMAT_REG0 = /^(((0?[1-9]|[12]\d|3[01]) ((J|j)an(uary)?|(M|m)a(r(ch)?|y)|(J|j)ul(y)?|(A|a)ug(ust)?|(O|o)ct(ober)?|(D|d)ec(ember)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((A|a)pr(il)?|(J|j)un(e)?|((S|s)ept|(N|n)ov)(ember)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((F|f)eb(ruary)?) ((19|20)\d{2}))|((0?[1-9]|[12]\d|30) ((F|f)eb(ruary)?) ((19|20)([13579][26]|[2468][048]|0[48]))))$/;
const DATE_FORMAT_REG1 = /^((0?[1-9]|[12]\d|3[01])\/(0?[13578]|1[02])\/((19|20)\d{2})|(0?[1-9]|[12]\d|30)\/(0?[469]|11)\/((19|20)\d{2})|(0?[1-9]|1\d|2[0-8])\/0?2\/((19|20)\d{2})|(0?[1-9]|[12]\d)\/0?2\/((19|20)([13579][26]|[2468][048]|0[48])))$/;
const DATE_FORMAT_REG2 = /^((0?[1-9]|[12]\d|3[01])\.(0?[13578]|1[02])\.((19|20)\d{2})|(0?[1-9]|[12]\d|30)\.(0?[469]|11)\.((19|20)\d{2})|(0?[1-9]|1\d|2[0-8])\.0?2\.((19|20)\d{2})|(0?[1-9]|[12]\d)\.0?2\.((19|20)([13579][26]|[2468][048]|0[48])))$/;
const DATE_FORMAT_REG3 = /^((0?[1-9]|[12]\d|3[01])|(0[1-9]|[12]\d|3[01])(0?[13578]|1[02])|(0[1-9]|[12]\d|30)(0?[469]|11)|(0[1-9]|1\d|2[0-8])(0?2)|(0[1-9]|[12]\d|3[01])(0[13578]|1[02])((19|20)?\d{2})|(0[1-9]|[12]\d|30)(0[469]|11)((19|20)?\d{2})|(0[1-9]|1\d|2[0-8])(02)((19|20)?\d{2})|(0[1-9]|[12]\d)(02)((19|20)?([13579][26]|[2468][048]|0[48])))$/;
 */
const Dash_Symbol = '-';

export default {
	name: 'DateMulti',
	props: {
		lableText: {
			type: String,
			default: ''
		},
		isIcon: {
			type: Boolean,
			default: true
		},
		startText: {
			type: String,
			default: 'Start Date'
		},
		endText: {
			type: String,
			default: 'End Date'
		},
		color: {
			type: String,
			default: ''
		},
		background: {
			type: String,
			default: '#FFFFFF'
		},
		dateInvalid: {
			type: String,
			default: 'Invalid date'
		},
		dateOverage: {
			type: String,
			default: 'Start date is after End date'
		},
		suggestionText: {
			type: String,
			default: 'eg, 120322-130322 or 12/3/2022-13/3/2022 or 12.3.2022-13.3.2022'
		},
		/**  accepts ISO 8601 date strings (YYYY-MM-DD) */
		dateStartInit: {
			type: String,
			default: ''
		},
		/**  accepts ISO 8601 date strings (YYYY-MM-DD) */
		dateEndInit: {
			type: String,
			default: ''
		},
		isWebsite: {
			type: Boolean,
			default: true
		},
		clearable: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: false
		},
		isSuggestion: {
			type: Boolean,
			default: false
		},
		isOptional: {
			type: Boolean,
			default: false
		},
		days: {
			type: Number,
			default: 0
		},
		workdays: {
			type: Array,
			default: () => ["monday", "tuesday", "wednesday", "thursday", "friday"]
		},
		error: {
			type: Boolean,
			default: false
		},
		validRange: {
			type: Array,
			default: () => []
		},
		hideDetails: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			menu: false,
			dates: this.getDates(),
			pickerPreDate: this.dateStartInit.length !== 0 ? moment(this.dateStartInit).format('YYYY-MM') : moment().format('YYYY-MM'),
			pickerNextDate: this.dateStartInit.length !== 0 ? moment(this.dateStartInit).add(1, 'M').format('YYYY-MM'): moment().add(1, 'M').format('YYYY-MM'),
			date_start: this.dateStartInit.length !== 0 ? this.dateStartInit : null,
			date_end: this.dateEndInit.length !== 0 ? this.dateEndInit : null,
			date_message: '',
			date_format: config.date_format
		}
	},
	components: {
		Calendar
	},
	computed: {
		displayDateRange() {
			if (this.dates.length === 1) {
				return `${this.formatDate(this.dates[0])} to ${this.endText}`;
			}
			if (this.dates.length > 1) {
				return `${this.formatDate(this.dates[0])} to ${this.formatDate(this.dates[1])}`;
			}
			return '';
		},
		maxPreMonth() {
			const date = moment(this.pickerPreDate, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
			return date
		},
		minNextMonth() {
			const date = moment(this.pickerNextDate, 'YYYY-MM').startOf('month').format('YYYY-MM-DD');
			return date
		},
	},
	watch: {
		dateStartInit() {
			this.date_start = this.dateStartInit.length !== 0 ? this.dateStartInit : null;
			this.pickerPreDate = this.dateStartInit.length !== 0 ? moment(this.dateStartInit).format('YYYY-MM') : moment().format('YYYY-MM');
			this.dates = this.getDates();
		},
		dateEndInit() {
			this.date_end = this.dateEndInit.length !== 0 ? this.dateEndInit : null;
			this.pickerNextDate = this.dateStartInit.length !== 0 ? moment(this.dateStartInit).add(1, 'M').format('YYYY-MM'): moment().add(1, 'M').format('YYYY-MM');
			this.dates = this.getDates();
		},
		menu(newVal, oldVal) {
			if (newVal === false && oldVal === true && this.dates.length === 1) {
				this.date_message = '';

				this.date_start = this.dates[0];
				this.date_end = this.dates[0];
				this.dates.push(this.date_end);

				if (this.date_start && this.date_end && this.date_start > this.date_end) {
					this.date_message = this.dateOverage;
				}

				this.$emit('dateRange', [this.date_start, this.date_end]);
			}
		},
		days() {
			this.onDaysChange();
		}
	},
	methods: {
		allowedDates(val) {
			if (this.validRange.length === 0) {
				return true
			} else {
				return val >= this.validRange[0] && val <= this.validRange[1]
			}
		},		
		getDates() {
			const date_arr = [];

			if (this.dateStartInit.length !== 0) {
				const start_date = this.dateStartInit;
				date_arr.push(start_date);
			}

			if (this.dateEndInit.length !== 0) {
				const end_date = this.dateEndInit;
				date_arr.push(end_date);
			}
			return date_arr;
		},
		formatDate(value) {
			if(!value) return null;
			return moment(value).format('DD MMM YYYY');
		},
		onPreMonthChange(current_month) {
			this.pickerNextDate = moment(current_month, ['YYYY-MM-DD', 'YYYY-MM']).add(1, 'M').format('YYYY-MM');
		},
		onNextMonthChange(current_month) {
			this.pickerPreDate = moment(current_month, ['YYYY-MM-DD', 'YYYY-MM']).subtract(1, 'M').format('YYYY-MM');
		},
		onDaysChange() {
			if (this.days !== 0 && this.date_start && this.date_end) {
				const start_date = this.date_start;
				
				let end_date = moment(start_date).add(0, 'days').format('YYYY-MM-DD');
				for (let index = 0; index < this.days -1; index++) {
					const date_tmp = moment(end_date).add(1, 'days').format('YYYY-MM-DD');
					end_date = this._isWorkDay(date_tmp, this.workdays);
				}
				this.date_start = start_date;
				this.date_end = end_date;
				this.dates = [this.date_start, this.date_end];
				this.$emit('dateRange', [this.date_start, this.date_end]);
			}

		},
		onDateChange(value_arr) {
			value_arr.sort();

			if (value_arr.length === 1) {		
				this.$refs.inputRef.focus();
				
				if (this.date_start && this.date_end) {
					if (value_arr[0] > this.date_end) {
						this.date_end = value_arr[0];
						this.dates.unshift(this.date_start);

						if (this.date_start && this.date_end && this.date_start > this.date_end) {
							this.date_message = this.dateOverage;
						}

						this.$emit('dateRange', [this.date_start, this.date_end]);
					}
					if (value_arr[0] < this.date_start) {
						this.date_start = value_arr[0];
						this.dates.push(this.date_end);

						if (this.date_start && this.date_end && this.date_start > this.date_end) {
							this.date_message = this.dateOverage;
						}

						this.$emit('dateRange', [this.date_start, this.date_end]);
					}
					if (value_arr[0] >= this.date_start && value_arr[0] <= this.date_end) {
						this.date_start = value_arr[0];
						this.date_end = null;
						this.dates = [this.date_start];
					}
				}

				if (!this.date_start && !this.date_end && this.days !== 0) {
					const start_date = value_arr[0];

					let end_date = moment(start_date).add(0, 'days').format('YYYY-MM-DD');
					for (let index = 0; index < this.days -1; index++) {
						const date_tmp = moment(end_date).add(1, 'days').format('YYYY-MM-DD');
						end_date = this._isWorkDay(date_tmp, this.workdays);
					}
					this.date_start = start_date;
					this.date_end = end_date;
					this.dates = [this.date_start, this.date_end];
					this.$emit('dateRange', [this.date_start, this.date_end]);
					if (this.menu) {
						setTimeout(() => {
							this.menu = false;
						}, 200);
					}
				}
			}

			if (value_arr.length > 1) {
				this.date_message = '';

				this.date_start = value_arr[0];
				this.date_end = value_arr[value_arr.length - 1];
				this.dates = [this.date_start, this.date_end];

				if (this.date_start && this.date_end && this.date_start > this.date_end) {
					this.date_message = this.dateOverage;
				}

				this.$emit('dateRange', [this.date_start, this.date_end]);

				if (this.menu) {
					setTimeout(() => {
						this.menu = false;
					}, 200);
				}
			}
		},
		onDateTextChange(date) {
			this.date_message = '';

			if (date) {
				if (date.includes(Dash_Symbol) || date.includes('to')) {
					const date_arr_tmp = date.includes(Dash_Symbol) ? date.split(Dash_Symbol) : date.split('to');
					const date_arr = date_arr_tmp.map(date => { return date.replace(/\s+/g,"") });
					date_arr.sort((a, b) => {
						const A = moment(a,  this.date_format).format('YYYY-MM-DD');
						const B = moment(b,  this.date_format).format('YYYY-MM-DD');
						return A > B
					});
					
					const date_A = date_arr[0].replace(/\s+/g,"");
					const date_B = date_arr[1].replace(/\s+/g,"");

					const isValid_A = moment(date_A, this.date_format).isValid();
					const isValid_B = moment(date_B, this.date_format).isValid();

					if (isValid_A && isValid_B) {
						this.dates = [];

						if (date_A === '31' && !moment(date_A, 'DD').isValid()) {
							const pre_month = moment().month() - 1;
							const pre_month_str = moment().month(pre_month).format('MM');
							const date_tmp = `${date_A}${pre_month_str}`;
							this.date_start = moment(date_tmp, 'DDMM').format('YYYY-MM-DD');
						} else {
							this.date_start = moment(date_A, this.date_format).format('YYYY-MM-DD');
						}
						this.dates.push(this.date_start);

						if (date_B === '31' && !moment(date_B, 'DD').isValid()) {
							const pre_month = moment().month() - 1;
							const pre_month_str = moment().month(pre_month).format('MM');
							const date_tmp = `${date_B}${pre_month_str}`;
							this.date_end = moment(date_tmp, 'DDMM').format('YYYY-MM-DD');
						} else {
							this.date_end = moment(date_B, this.date_format).format('YYYY-MM-DD');
						}
						this.dates.push(this.date_end);

						if (this.date_start && this.date_end && this.date_start > this.date_end) {
							this.date_message = this.dateOverage;
						}
						this.$emit('dateRange', [this.date_start, this.date_end]);
					} else {
						this.date_message = this.dateInvalid;
						this.$emit('dateRange', []);
					}
				} else {
					const date_A = date.replace(/\s+/g,"");
					const isValid_A = moment(date_A, this.date_format).isValid();
					if (isValid_A) {
						const start_date = moment(date_A, this.date_format).format('YYYY-MM-DD');
						if (this.date_start && this.date_end) {
							if (start_date > this.date_end) {
								this.date_end = start_date;
								this.dates.unshift(this.date_start);

								if (this.date_start && this.date_end && this.date_start > this.date_end) {
									this.date_message = this.dateOverage;
								}

								this.$emit('dateRange', [this.date_start, this.date_end]);
							}
							if (start_date < this.date_start) {
								this.date_start = start_date;
								this.dates.push(this.date_end);

								if (this.date_start && this.date_end && this.date_start > this.date_end) {
									this.date_message = this.dateOverage;
								}

								this.$emit('dateRange', [this.date_start, this.date_end]);
							}
							if (start_date >= this.date_start && start_date <= this.date_end) {
								this.date_start = start_date;
								this.date_end = null;
								this.dates = [this.date_start];
							}
						}

						if (!this.date_start && !this.date_end) {
							const start_date = moment(date_A, this.date_format).format('YYYY-MM-DD');
							let end_date = moment(start_date).add(0, 'days').format('YYYY-MM-DD');

							const days = this.days !== 0 ? this.days : 1;
							for (let index = 0; index < days -1; index++) {
								const date_tmp = moment(end_date).add(1, 'days').format('YYYY-MM-DD');
								end_date = this._isWorkDay(date_tmp, this.workdays);
							}

							this.date_start = start_date;
							this.date_end = end_date;
							this.dates = [this.date_start, this.date_end];
							this.$emit('dateRange', [this.date_start, this.date_end]);
						}
					} else {
						this.date_message = 'Invalid format';
						this.$emit('dateRange', []);
					}
				}
			} else {
				this.$emit('dateRange', []);
			}
		},
		onInputClear(text) {
			if (typeof(text) === 'string' && text.length === 0) {
				this.onClear();
			}
		},
		onClear() {
			this.dates = [];
			this.date_start = null;
			this.date_end = null;
			this.date_messages = '';
			this.$emit('dateRange', []);
		},
		onKeydown(e) {
			if (e.keyCode === 13) {
				this.menu = false;
			}
		},
		_isWorkDay(current_day, workdays) {
			let end_date = moment(current_day).format('YYYY-MM-DD');

			if (!workdays.includes((moment(end_date).format('dddd')).toLocaleLowerCase()) && workdays.length !== 0) {
				const end_date_tmp = moment(current_day).add(1, 'days').format('YYYY-MM-DD');
				end_date = this._isWorkDay(end_date_tmp, workdays);
			}
			
			return end_date;
		}
	}
}
</script>
<style lang="scss" scoped>
.lable-text {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
  opacity: 0.87;
}
.lable-text-disable {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #B9C2CB;
  opacity: 0.87;
}
.optional-text {
	position: relative;
  top: -26px;

	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 12px;
	line-height: 20px;

	text-align: right;
	letter-spacing: 0.4px;
	color: #37495F;
}

.icon-hover {
	&:hover {
		cursor: pointer;
	}
}
</style>